/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint react/prop-types: off */

import React, { useRef } from 'react'
import Select from 'react-select'
import { MixedTags } from '@yaireo/tagify/dist/react.tagify'
import { FormInput, FormInputText, Icon, Tip } from 'camino-react'

const customValues = [
  { label: 'Title', value: 'title' },
  { label: 'ID', value: 'id' },
  { label: 'Client', value: 'client' },
  { label: 'Description', value: 'description' },
  { label: 'Ticket Type', value: 'ticket_type' },
  { label: 'Client Contact', value: 'client_contact' },
  { label: 'Priority', value: 'priority' }
]

const ticketMembersOptions = [
  { value: 'assignee_user_id', label: 'Assignee' },
  { value: 'client_contact_id', label: 'Client contact' },
  { value: 'escalation_owner_id', label: 'Escalation owner' },
  { value: 'escalation_queue_id', label: 'Escalation queue' },
  { value: 'queue_id', label: 'Queue' },
  { value: 'secondary_contact_email', label: 'Secondary contact' },
  { value: 'resolver_id', label: 'Resolver' }
]

const recipientOptions = [
  { label: 'Ticket Member', value: 'ticket_member' },
  {
    label: 'Specific User',
    value: 'specific_user'
  },
  {
    label: 'Specific Queue',
    value: 'specific_queue'
  },
  {
    label: 'Custom Email',
    value: 'custom_email'
  }
]

const frequencyOptions = [
  { value: '0', label: 'One off' },
  { value: '10', label: '10 minutes' },
  { value: '20', label: '20 minutes' },
  { value: '30', label: '30 minutes' },
  { value: '40', label: '40 minutes' },
  { value: '50', label: '50 minutes' },
  { value: '60', label: '1 hour' },
  { value: '70', label: '1 hour, 10 minutes' },
  { value: '80', label: '1 hour, 20 minutes' },
  { value: '90', label: '1 hour, 30 minutes' },
  { value: '100', label: '1 hour, 40 minutes' },
  { value: '110', label: '1 hour, 50 minutes' },
  { value: '120', label: '2 hours' }
]

const SendNotificationAction = ({
  update,
  operations: { frequency, recipients = [], body },
  options: { employees, queues }
}) => {
  const bodyRef = useRef()

  const settings = {
    pattern: /#/,
    enforceWhitelist: true,
    editTags: false,
    mixTagsInterpolator: ['<<', '>>'],
    dropdown: {
      enabled: 0,
      position: 'text'
    },
    whitelist: customValues.map(customValue => (
      { value: customValue.label, field: customValue.value }
    ))
  }

  const handleBody = () => {
    update('body', bodyRef.current.state.lastOriginalValueReported)
  }

  const addRecipient = () => {
    update('recipients', [...recipients, { type: null, value: null }])
  }

  const removeRecipient = (rec) => {
    update('recipients', recipients.filter(recipient => recipient !== rec))
  }

  const recipientSubOptions = {
    ticket_member: ticketMembersOptions,
    specific_user: employees,
    specific_queue: queues
  }

  const handleRecipientType = (recipient, type) => {
    const newRecipients = [...recipients]
    const recipientToUpdate = newRecipients.find(r => r === recipient)
    recipientToUpdate.type = type
    recipientToUpdate.value = null

    update('recipients', newRecipients)
  }

  const handleRecipientValue = (recipient, value) => {
    const newRecipients = [...recipients]
    const recipientToUpdate = newRecipients.find(r => r === recipient)
    recipientToUpdate.value = value

    update('recipients', newRecipients)
  }

  return (
    <>
      <div>
        <label className="mb-6">Recipients</label>
        {recipients?.map((recipient, index) => (
          <div className="flex items-center -mt-4">
            <Select
              options={recipientOptions}
              value={recipient?.type}
              placeholder="Select Recipient Type"
              onChange={e => handleRecipientType(recipient, e.value)}
              className="flex-1 mr-4 Select--no-bottom-margin"
            />

            {recipient.type === 'custom_email' ? (
              <div className="mb-8 flex-1 mr-4">
                <FormInputText
                  value={recipient.value}
                  onValue={value => handleRecipientValue(recipient, value)}
                />
              </div>
            ) : (
              <Select
                options={recipientSubOptions[recipient?.type]}
                value={recipient.value}
                placeholder="Select Recipient"
                onChange={e => handleRecipientValue(recipient, e.value)}
                className="flex-1 mr-4 Select--no-bottom-margin"
              />
            )}

            <div className="flex-0 mb-6 w-9">
              <button
                className="text-3xl text-blue-500 hover:text-blue-700 cursor-pointer duration-300"
                onClick={() => removeRecipient(recipient)}
                type="button"
              >
                <Icon type="trash" />
              </button>
            </div>
          </div>
        ))}

        <div className="mb-4 -mt-4">
          <button
            className="text-2xl font-semibold text-blue-500 hover:text-blue-700 cursor-pointer duration-300"
            onClick={addRecipient}
            type="button"
          >
            Add Recipient
          </button>
        </div>
      </div>

      <div className="flex items-center justify-end text-xl">
        <span className="mr-2">How to add custom values?</span>

        <Tip content="If you want to add custom values, just type # and then a
          list of available values will appear"
        />
      </div>

      <div>
        <label>Body</label>
        <MixedTags
          className="mb-4 border border-blue-100 rounded focus:border-blue-300"
          tagifyRef={bodyRef}
          settings={settings}
          onChange={handleBody}
          onInput={handleBody}
          value={body}
        />
      </div>

      <FormInput label="Frequency">
        <Select
          value={frequency}
          onChange={e => update('frequency', e.value)}
          options={frequencyOptions}
        />
      </FormInput>

    </>
  )
}

export default SendNotificationAction
